<template>
  <div class="layout">
    <template v-if="isModal">
      <div class="cancel" @click="$emit('close')">
        <i class="el-icon-close" style="font-size: 30px"></i>
      </div>
    </template>
    <template v-if="isMeaningful(data)">
      <div class="left">
        <div style="text-align: center; margin-bottom: 60px">
<!--          <div style="margin-bottom: 20px;">-->
<!--            <img src="../../../../../../assets/images/logo.png" style="width: 200px"/>-->
<!--          </div>-->
          <div>
            <div class="left-version-font">版本更新公告</div>
            <div class="left-version-date">{{convertToFullDate(new Date(data.createTime), 'yyyy.MM.dd')}}</div>
          </div>
        </div>
        <div class="left-list" :style="{height: isModal ? (clientWidth > 1600 ? 'calc(100vh - 445px)' : 'calc(100vh - 320px)') : 'calc(100vh - 470px)'}">
          <div
              v-for="(item, index) in data.itemList"
              :key="index" class="left-list-item"
              :class="{'list-item-checked--color': item.id === checkedFeatures.id}"
              @click="checkedFeature(item)"
          >
            <template v-if="item.id === checkedFeatures.id">
              <gj-area-title style="margin-bottom: 0; padding-left: 10px">{{item.itemTitle}}</gj-area-title>
            </template>
            <template v-else>
              {{item.itemTitle}}
            </template>
          </div>
        </div>
      </div>
      <div class="content" v-if="isMeaningful(checkedFeatures)" :style="{padding: isModal ? 'padding: 30px 60px 0 60px;' : 'padding: 30px 60px 0 60px;'}">
        <div style="margin-bottom: 20px">
          <gj-area-title>
            {{checkedFeatures.itemTitle}}
          </gj-area-title>
        </div>
        <div style="padding-left: 14px; font-size: 12px; color: #333333; margin-bottom: 60px" v-html="checkedFeatures.content">

        </div>
        <gj-area-title>展示图例</gj-area-title>
        <div style="width: 600px; height: 400px">
          <el-carousel indicator-position="outside" trigger="click" height="400px">
            <el-carousel-item v-for="(item, index) in checkedFeatures.imageUrlList" :key="index">
              <div @click="previewImage(item)">
                <img :src="item" class="carousel-image" />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </template>
    <el-image
        ref="elImage"
        style="width: 0;"
        :src="previewImgList[0]"
        :preview-src-list="previewImgList">
    </el-image>
  </div>
</template>

<script>
  import {convertToFullDate} from "../../../../../../utils/date.util";
  import {isMeaningfulMixin} from "../../../../../../minxins";
  import {isMeaningful, isMeaningless} from "../../../../../../utils/common";

  export default {
    name: "app-version-announcement-template",
    mixins: [isMeaningfulMixin],
    props: {
      isModal: {
        type: Boolean,
        default: true,
      },
      data: null
    },
    watch: {
      data: {
        immediate: true,
        handler() {
          if (isMeaningful(this.data) && this.data.itemList.length > 0) {
            this.data.itemList.forEach((item, index) => {
              if (isMeaningless(item.id)) {
                item.id = index;
              }
            });
            this.checkedFeatures = this.data.itemList[0];
          } else {
            this.checkedFeatures = null;
          }
        }
      }
    },
    data() {
      return {
        previewImgList: [],
        convertToFullDate: convertToFullDate,
        checkedFeatures: null,
      }
    },
    methods: {
      checkedFeature(item) {
        this.checkedFeatures = item;
      },
      previewImage(image) {
        const imgList = [...this.checkedFeatures.imageUrlList];
        if (imgList.length > 1) {
          const chooseIndex = imgList.findIndex(item => item === image);
          this.previewImgList = [...imgList.filter((_, index) => index >= chooseIndex), ...imgList.filter((_, index) => index < chooseIndex)];
        } else {
          this.previewImgList = [image];
        }
        setTimeout(() => this.$refs['elImage'].clickHandler());
      }
    }
  }
</script>

<style scoped>

  .layout {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
  }

  .cancel {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }

  .left {
    width: 300px;
    height: 100%;
    background-color: #f8f8f8;
    padding: 20px 0;
    box-sizing: border-box;
  }

  .left-version-font {
    font-size: 36px;
    font-weight: 500;
    line-height: 61px;
    color: #333333;
  }

  .left-version-date {
    font-size: 16px;
    font-weight: 500;
    line-height: 27px;
    color: #888888;
  }

  .left-list {
    overflow-y: hidden;
  }

  .left-list:hover {
    overflow-y: overlay;
  }

  .carousel-image {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }

  .left-list-item {
    padding-left: 30px;
    cursor: pointer;
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666666;
  }

  .list-item-checked--color {
    background-color: #ffffff;
    color: #333333!important;
    font-weight: bold;
    margin-left: -14px;
  }

  .content {
    overflow-y: hidden;
    flex: 1;
    padding: 30px 60px 0 60px;
    box-sizing: border-box;
  }

  .content:hover {
    overflow-y: overlay;
  }
</style>
